import React from 'react'
import {
  generalBsBreakpoint,
  generalBsBreakpointValue,
} from '../../../constants/constants'

type Props = {
  children: JSX.Element
}

export const isMobile = window.innerWidth <= generalBsBreakpointValue // Note: isMobile requires refresh on resize of window to update. Whereas Mobile and Desktop do not.

export const Desktop: React.FC<Props> = ({ children }) => {
  return (
    <>
      <div className={`d-none d-${generalBsBreakpoint}-block`}>{children}</div>
    </>
  )
}

export const Mobile: React.FC<Props> = ({ children }) => {
  return (
    <>
      <div className={`d-${generalBsBreakpoint}-none`}>{children}</div>
    </>
  )
}

export const DesktopRender: React.FC<Props> = ({ children }) => {
  return isMobile ? (
    <></>
  ) : (
    <>
      <div className={`d-none d-${generalBsBreakpoint}-block`}>{children}</div>
    </>
  )
}

export const MobileRender: React.FC<Props> = ({ children }) => {
  return isMobile ? (
    <>
      <div className={`d-${generalBsBreakpoint}-none`}>{children}</div>
    </>
  ) : (
    <></>
  )
}
